import React from 'react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useTabPages, TabPage } from '@ts-core/core/hooks/ui';

import { useAcademyAuthUtils } from 'modules/auth/hooks';

import StudentAssignmentsPage from 'modules/assignments/pages/StudentAssignmentsPage';
import StudentPracticeSessionsPage from 'modules/practice/pages/StudentPracticeSessionsPage';
import StudentMediaStatsPage from 'modules/media/pages/StudentMediaStatsPage';

export default function useStudentDetailsTabPages() {
  const intl = useIntl();
  const { academyHasFeature, Feature } = useAcademyAuthUtils();

  const pages = useMemo((): TabPage[] => {
    const result = [
      {
        page: <StudentAssignmentsPage />,
        tab: {
          label: intl.formatMessage({ id: 'assignments' }),
          slug: 'assignments',
        },
      },
      {
        page: <StudentPracticeSessionsPage />,
        tab: {
          label: intl.formatMessage({ id: 'practiceSessions.title' }),
          slug: 'practice',
        },
      },
    ];

    if (academyHasFeature(Feature.VideoOnDemand)) {
      result.push({
        page: <StudentMediaStatsPage />,
        tab: {
          label: intl.formatMessage({ id: 'student.mediaStats' }),
          slug: 'media-stats',
        },
      });
    }

    return result;
  }, [intl, academyHasFeature, Feature]);

  return useTabPages({ pages, slugParam: 'tab' });
}
